/* eslint-disable camelcase */
import dayjs from 'dayjs'

import { IProfile, IServerProfile, IServerUserInfo, IUserInfo } from 'shared/models/Profile'

import {
  ISlotsHistory,
  ISlotsHistoryDTO,
  ISlotsHistoryItem,
} from './types/types'

export class ProfileConverter {
  convertProfileInfo(data: IServerProfile): IProfile {
    return {
      id: data.id,
      username: data.username,
      dateJoined: dayjs(data.date_joined).format('DD/MM/YYYY'),
      balanceCurrency: data.balance_currency,
      balance: data.balance,
      isBanned: data.is_banned,
    }
  }

  convertUserInfo(data: IServerUserInfo): IUserInfo {
    return {
      firstName: data.first_name,
      lastName: data.last_name,
      gender: data.gender,
      email: data.email,
      dateOfBirth: data.date_of_birth,
      country: data.country,
      city: data.city,
      streetAddress: data.street_address,
      mobileNumber: data.mobile_number,
      residenceDocument: data.residence_document,
      isConfirmedMail: data.is_email_verified ?? false,
    }
  }

  convertSlotsHistory = (data: ISlotsHistoryDTO): ISlotsHistory => {
    const items: ISlotsHistoryItem[] =
      data.results.map(item => ({
        provider: item.provider,
        date: item.date,
        balance: `${Math.floor(+item.balance_before * 100) / 100} → ${Math.floor(+item.balance_after * 100) / 100} ${item.balance_after_currency
          }`,
        status: item.status,
        betAmount: `${Math.floor(+item.bet_amount * 100) / 100}`,
        winAmount: `${Math.floor(+item.win_amount * 100) / 100}`,
        gameId: item.game_id,

        id: item.id,
        amount: item.amount,
        balanceAfter: item.balance_after,
        balanceAfterCurrency: item.balance_after_currency,
        balanceBefore: item.balance_before,
        balanceBeforeCurrency: item.balance_before_currency,
        coef: item.coef,
        isFreeSpin: item.is_free_spin,
        producer: item.producer,
        roundId: item.round_id,
        transactionReference: item.transaction_reference,
        updatedAt: item.updated_at,
        userPromotion: item.user_promotion,
        uuid: item.uuid,
      })) || []
    return {
      count: data.count,
      items,
    }
  }
}
